import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { UserDataService } from '../../services/user-data/user-data.service';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
    standalone: false,
    selector: 'octo-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit, OnDestroy {
    baseState = '';
    currentURL = '';
    currentState = '';
    isAdmin = false;
    isCollapsed: any = {
        myAccount: false,
        dashboard: false,
    };
    isNavbarCollapsed = false;
    userSummary$ = new Subscription();
    userSummary: any;
    jtvData: any = null;
    subscriptions$ = new Subscription();
    uberConnectFlag: boolean = environment.UBER_CONNECT_DASHBOARD_FLAG;
    isNotUberConnected: boolean = false;

    constructor(
        private authService: AuthenticationService,
        private userDataService: UserDataService,
        private router: Router,
        private cookieService: CookieService,
        private cdr: ChangeDetectorRef
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((val: any) => {
                this.currentURL = val.urlAfterRedirects;
                this.setBaseState();
            });
        this.userSummary$ = this.userDataService
            .getUserSummary()
            .subscribe((data: any) => {
                this.userSummary = data;
                if (this.userSummary) {
                    this.uberConnectFlag =
                        this.uberConnectFlag ||
                        environment.ALLOWED_DOMAINS.includes(
                            this.userSummary?.email.split('@').pop()?.toLowerCase()
                        );
                    this.checkUberConnection();
                }
                if (this.userSummary?.status === 'former_driver') {
                    this.isCollapsed.myAccount = true;
                }
            });
    }

    ngOnInit(): void {
        this.isAdmin = this.authService.isAdmin();
        this.setBaseState();
        this.fetchJourneyTVData();
        this.checkUberConnection();
    }

    checkUberConnection(): void {
        if (this.userSummary) {
            if (
                (this.userSummary?.journey_tv === null ||
                    this.userSummary?.journey_tv?.matched_identifier?.length == 0 ||
                    this.userSummary?.journey_tv?.matched_identifier === null
                ) &&
                !['DEVICE_STATUS_ACTIVE', 'PROVISIONED'].includes(
                    this.userSummary?.journey_tv?.status?.toUpperCase?.()
                ) &&
                this.userSummary?.uber_connect?.status?.toUpperCase() !==
                'CONNECTED' &&
                this.cookieService.get('dontHaveUber') !== 'true'
            ) {
                this.isNotUberConnected = true;
            }
            this.cdr.detectChanges();
        }
    }

    fetchJourneyTVData(): void {
        this.subscriptions$.add(
            this.userDataService.fetchJourneyTVTracker().subscribe({
                next: (data: any) => {
                    if (data?.data) {
                        this.jtvData = data.data;
                        setTimeout(() => this.cdr.detectChanges());
                    }
                },
                error: (error: any) => {
                    console.error('Error fetching JourneyTV tracker data:', error);
                }
            })
        );
    }

    get showJourneyTV(): boolean {
        const uberNotConnected = this.isNotUberConnected || this.cookieService.get('dontHaveUber') === 'true';
        const result = !!(
            this.jtvData &&
            !(this.uberConnectFlag && uberNotConnected) &&
            this.userSummary?.status !== 'interested_mail_delivered' &&
            !this.userSummary?.is_partner
        );
        return result;
    }

    goToPage(url: string) {
        this.router.navigate([url]);
    }

    isActive(url: string): boolean {
        return this.currentURL.includes(url);
    }

    logOut() {
        this.isNavbarCollapsed = true;
        this.authService.logOut();
    }

    setBaseState(): void {
        // remove https:// from the string
        if (!this.currentURL) this.currentURL = this.router.url;
        let urlNoProtocol = this.currentURL.replace(/^https?\:\/\//i, '');
        this.baseState = urlNoProtocol.substring(
            urlNoProtocol.indexOf('/') + 1,
            urlNoProtocol.lastIndexOf('/')
        );
        if (this.baseState === 'my-account') {
            this.isCollapsed.myAccount = true;
            this.isCollapsed.dashboard = false;
        } else {
            this.isCollapsed[this.baseState] = true;
            if (this.userSummary?.status !== 'former_driver') {
                this, (this.isCollapsed.myAccount = false);
            }
        }
    }

    ngOnDestroy(): void {
        this.userSummary$.unsubscribe();
        this.subscriptions$.unsubscribe();
    }
}
